import React from 'react';

const Button = ({ children, onClick, className }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      className={`mr-2 rounded-md border px-4 py-1 text-xs text-black transition duration-300 ease-in-out ${className} backdrop:blur-[10px]`}
      // style={{
      //     backdropFilter: 'blur(10px)',
      //     backgroundColor: 'rgba(255, 255, 255, 0.2)', // Adjust alpha value as needed
      //     border: ' solid rgba(255, 255, 255, 0.5)', // Custom border style
      //     boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)', // Adding a shadow for depth
      // }}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

export default Button;
